import { lzDateAddDays, lzDateAddMonths, lzDateAddYears } from "../services/LzMoment";
import { lzIsArray } from "../services/LzType";
import GatewaySubscriptionModel from "./gateway-subscription";
import LzOptionModel from "./option";

export default class SubscriptionModel {

    static STATUS_CREATED = 1;
    static STATUS_PAYMENT_DONE = 2;
    static STATUS_PAYMENT_FAILED = 3;
    static STATUS_ACTIVE = 4;
    static STATUS_EXPIRED = 5;
    static STATUS_CANCELLED = 6;
    static STATUS_REFUNDED = 7;

    static STATUS_NAMES = {
        1: 'Created (Payment Pending)',
        2: 'Payment Done',
        3: 'Payment Failed',
        4: 'Active',
        5: 'Expired',
        6: 'Cancelled',
        7: 'Refunded',
    };

    constructor(model) {
        if (!model) {
            model = {};
        }

        this.id = model.id ? +model.id : 0;
        this.package_name = model.package_name ? model.package_name : '';
        this.package_summary = model.package_summary ? model.package_summary : '';
        this.term = model.term ? +model.term : 0;
        this.cost = model.cost ? +model.cost : 0;
        this.status = model.status ? +model.status : SubscriptionModel.STATUS_CREATED;
        this.started_at = model.started_at ? model.started_at.substring(0, 10) : '';
        this.ended_at = model.ended_at ? model.ended_at.substring(0, 10) : '';
        this.is_active = typeof model.is_active === 'undefined' ? true : !!model.is_active;
        this.created_at = model.created_at ? model.created_at : '';
        this.updated_at = model.updated_at ? model.updated_at : '';
        this.deleted_at = model.deleted_at ? model.deleted_at : '';

        this.gateway_subscription = model.gateway_subscription ? new GatewaySubscriptionModel(model.gateway_subscription) : null;
    }

    get is_monthly() {
        return SubscriptionModel.isMonthly(this.term);
    }

    get term_name() {
        return this.is_monthly ? 'Monthly' : 'Yearly';
    }

    get status_name() {
        return SubscriptionModel.getStatusName(this.status);
    }

    evaluateEndedAt() {
        if (this.started_at && this.started_at !== '') {
            this.ended_at = this.is_monthly ? lzDateAddMonths(this.started_at, 1) : lzDateAddYears(this.started_at, 1);
            this.ended_at = lzDateAddDays(this.ended_at, -1);
        } else {
            this.ended_at = '';
        }
    }

    static parseArray(data) {
        if (!lzIsArray(data)) {
            return [];
        }

        const out = [];
        for (const item of data) {
            out.push(new SubscriptionModel(item));
        }

        return out;
    }

    static getStatusName(status) {
        return SubscriptionModel.STATUS_NAMES[status];
    }

    static getStatusOptions() {
        const out = [];
        const keys = Object.keys(SubscriptionModel.STATUS_NAMES);
        for (const key of keys) {
            out.push(new LzOptionModel({ value: key, text: SubscriptionModel.STATUS_NAMES[key] }));
        }
        // console.log('Subscription Options:', out);
        return out;
    }

    static isMonthly(term) {
        return 30 === term;
    }

}
